import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Competition_entry } from '../models/competition_entry';
import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class CompetitionEntryService {

  constructor(private http: HttpClient) { }

  get(id: string): Promise<Competition_entry> {
    return this.getWithRestUrlSegment('id/' + id);
  }

  getByNumber(horse_show_id: string, competition_number: number, entry_number: number): Promise<Competition_entry> {
    return this.getWithRestUrlSegment('horse_show_id/' + horse_show_id + '/competition_number/' + competition_number + "/entry_number/" + entry_number);
  }

  private getWithRestUrlSegment(rest_url_segment: string): Promise<Competition_entry> {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'competition_entries/' + rest_url_segment).subscribe((response:any) => {
      if(response.type == 'competition_entry' && response.data){
        resolve(response.data);
      } else {
        reject(response);
      }

    },
      error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
  });
  }


  public getCompetitionEntryListForEntryInSection(entry_id: string, section_number: number): Promise<Competition_entry[]> {
  	return this.getCompetitionEntryListWithRESTUrlFilter('/entry_id/' + entry_id + '/section_number/' + section_number);
  }

  private getCompetitionEntryListWithRESTUrlFilter(rest_url: string): Promise<Competition_entry[]> {
    	   return new Promise((resolve, reject) => {
				return this.http.get(AppSettings.API_ENDPOINT + 'competition_entries' + rest_url).subscribe((response:any) => {
					if(response.type == 'competition_entries' && response.data){
						resolve(response.data);
					} else {
						reject(response);
					}

				},
					error => {
			      		if(error instanceof HttpErrorResponse){
            	  			reject(error.error);
            			} else {
            				reject(error);
            			}
					});
			});
    }

}
